import { render, staticRenderFns } from "./orderAddress.vue?vue&type=template&id=4add5050&scoped=true"
import script from "./orderAddress.vue?vue&type=script&lang=js"
export * from "./orderAddress.vue?vue&type=script&lang=js"
import style0 from "./orderAddress.vue?vue&type=style&index=0&id=4add5050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add5050",
  null
  
)

export default component.exports